import { render, staticRenderFns } from "./TweetCards.vue?vue&type=template&id=bdab8e32&"
import script from "./TweetCards.vue?vue&type=script&lang=js&"
export * from "./TweetCards.vue?vue&type=script&lang=js&"
import style0 from "./TweetCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports